import React from 'react'
import { useState , useEffect} from 'react';
import {  getCampaignCopyDetail} from '../../services/api';
import { useLocation } from "react-router";
import CampaignForm from '../CampaignForm/CampaignForm';
import CustomCampaignForm from '../CustomCampaignForm'

const NewCampaign = (props) => {

  const location = useLocation()

  const [campaign, setCampaign] = useState(null)
  const [isCustom, setIsCustom] = useState(false)
  const [loading, setLoading] = useState(true)

  useEffect(async () => {
    setLoading(true)
    const idCampaign = location.pathname.split('campaigns/new/')[1];
    if(idCampaign && idCampaign !== 'custom'){
      const {data} = await getCampaignCopyDetail(idCampaign)
      setCampaign(data)
      setIsCustom(data.withVariables)
    } else if(idCampaign == 'custom') {
      setIsCustom(true)
    }
    setLoading(false)
  }, []);

    return (
      <React.Fragment>
      {!loading &&
       (isCustom ? (
          <CustomCampaignForm
            formType={'new'}
            campaignInfo={campaign}
            disableInputs={{
              disableBusiness: campaign ? true : false,
            }}
          />
        ) : (
        <CampaignForm
          formType={'new'}
          campaignInfo={campaign}
          disableInputs={{
            disableBusiness: campaign ? true : false,
          }}
        />
       ))
      }
      
    </React.Fragment>
    );
}

NewCampaign.propTypes = {

}

export default NewCampaign
